import { NxAccordionModule } from "@allianz/ng-aquila/accordion";
import { NxActionModule } from "@allianz/ng-aquila/action";
import { NxAutocompleteModule } from "@allianz/ng-aquila/autocomplete";
import { NxBadgeModule } from "@allianz/ng-aquila/badge";
import { NxErrorModule, NxLabelModule } from "@allianz/ng-aquila/base";
import { NxBreadcrumbModule } from "@allianz/ng-aquila/breadcrumb";
import { NxButtonComponent, NxButtonModule } from "@allianz/ng-aquila/button";
import { NxCardModule } from "@allianz/ng-aquila/card";
import { NxCheckboxModule } from "@allianz/ng-aquila/checkbox";
import { NxContextMenuModule } from "@allianz/ng-aquila/context-menu";
import { NxCopytextModule } from "@allianz/ng-aquila/copytext";
import { NxDataDisplayModule } from "@allianz/ng-aquila/data-display";
import {
  NxDatefieldModule,
  NxNativeDateModule,
} from "@allianz/ng-aquila/datefield";
import { NxDropdownModule } from "@allianz/ng-aquila/dropdown";
import { NxFormfieldModule } from "@allianz/ng-aquila/formfield";
import { NxGridModule } from "@allianz/ng-aquila/grid";
import { NxHeaderModule } from "@allianz/ng-aquila/header";
import { NxHeadlineModule } from "@allianz/ng-aquila/headline";
import { NxIconModule } from "@allianz/ng-aquila/icon";
import { NxIndicatorModule } from "@allianz/ng-aquila/indicator";
import { NxInputModule } from "@allianz/ng-aquila/input";
import { NxLinkModule } from "@allianz/ng-aquila/link";
import { NxListModule } from "@allianz/ng-aquila/list";
import { NxMaskModule } from "@allianz/ng-aquila/mask";
import { NxMenuModule } from "@allianz/ng-aquila/menu";
import { NxMessageModule } from "@allianz/ng-aquila/message";
import { NxModalModule } from "@allianz/ng-aquila/modal";
import { NxMomentDateModule } from "@allianz/ng-aquila/moment-date-adapter";
import { NxNaturalLanguageFormModule } from "@allianz/ng-aquila/natural-language-form";
import { NxNumberStepperModule } from "@allianz/ng-aquila/number-stepper";
import { NxPageSearchModule } from "@allianz/ng-aquila/page-search";
import { NxPaginationModule } from "@allianz/ng-aquila/pagination";
import {
  NxPopoverComponent,
  NxPopoverModule,
} from "@allianz/ng-aquila/popover";
import { NxProgressStepperModule } from "@allianz/ng-aquila/progress-stepper";
import { NxProgressbarModule } from "@allianz/ng-aquila/progressbar";
import { NxRadioModule } from "@allianz/ng-aquila/radio-button";
import { NxRadioToggleModule } from "@allianz/ng-aquila/radio-toggle";
import { NxSpinnerModule } from "@allianz/ng-aquila/spinner";
import { NxSwitcherModule } from "@allianz/ng-aquila/switcher";
import { NxTableModule } from "@allianz/ng-aquila/table";
import { NxTabsModule } from "@allianz/ng-aquila/tabs";
import { NxTaglistModule } from "@allianz/ng-aquila/taglist";
import { NxTooltipModule } from "@allianz/ng-aquila/tooltip";
import { NxVideoModule } from "@allianz/ng-aquila/video";
import { TextFieldModule } from "@angular/cdk/text-field";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { MatMenuModule } from "@angular/material/menu";
import { RouterModule } from "@angular/router";
import { HasRoleDirective } from "@directives/has-role.directive";
import { OnlyNumberDirective } from "@directives/only-number.directive";
import { NxPopoverControllerDirective } from "@directives/popover.directive";
import { CampaignCardComponent } from "@modules/campaigns/campaign-card/campaign-card.component";
import { ClubCampaignCardComponent } from "@modules/campaigns/club-campaign-card/club-campaign-card.component";
import { PreviewCampaignCardComponent } from "@modules/campaigns/preview-campaign-card/preview-campaign-card.component";
import { GroupsChartComponent } from "@modules/chart/groups-chart/groups-chart.component";
import { LineChartComponent } from "@modules/chart/line-chart/line-chart.component";
import { PieChartComponent } from "@modules/chart/pie-chart/pie-chart.component";
import { StackedGroupsChartComponent } from "@modules/chart/stacked-groups-chart/stacked-groups-chart.component";
import { CustomStepperComponent } from "@modules/custom-stepper/custom-stepper.component";
import { DashboardAnnouncementsComponent } from "@modules/dashboard-announcements/dashboard-announcements.component";
import { EventCardComponent } from "@modules/event-management/event-card/event-card.component";
import { FormPaginationComponent } from "@modules/forms/form-pagination/form-pagination.component";
import { SearchFormPaginationComponent } from "@modules/forms/search-form-pagination/search-form-pagination.component";
import { SearchFormPaginationCustomMbComponent } from "@modules/forms/search-form-pagination-custom-mb/search-form-pagination-custom-mb.component";
import { TableSortMbComponent } from "@modules/table-sort-mb/table-sort-mb.component";
import { TranslateModule } from "@ngx-translate/core";

import { ScrollTopComponent } from "./components/scroll-top/scroll-top.component";
import { ExternalScrollbarModule } from "./modules/external-scrollbar/external-scrollbar.module";
import { SyncScrollModule } from "./modules/sync-scroll/sync-scroll.module";
import { IsBtnLinkValidPipe } from "./pipes/btn-link-valid.pipe";
import { DateFormatPipe } from "./pipes/date-format.pipe";
import { ListFilterPipe } from "./pipes/list-filter.pipe";
import { NumberToReadablePipe } from "./pipes/number-to-readable.pipe";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { SortAlphabetPipe } from "./pipes/sort-alphabet.pipe";

@NgModule({
  imports: [
    CommonModule,
    PieChartComponent,
    LineChartComponent,
    StackedGroupsChartComponent,
    GroupsChartComponent,
    CampaignCardComponent,
    ClubCampaignCardComponent,
    NumberToReadablePipe,
    PreviewCampaignCardComponent,
    EventCardComponent,
    FormPaginationComponent,
    SearchFormPaginationComponent,
    SearchFormPaginationCustomMbComponent,
    TableSortMbComponent,
    CustomStepperComponent,
    HasRoleDirective,
    ExternalScrollbarModule,
    FormsModule,
    GoogleMapsModule,
    NxIconModule,
    NxAccordionModule,
    NxActionModule,
    NxAutocompleteModule,
    NxBadgeModule,
    NxBreadcrumbModule,
    NxButtonModule,
    NxCardModule,
    NxCheckboxModule,
    NxContextMenuModule,
    NxCopytextModule,
    NxDataDisplayModule,
    NxDatefieldModule,
    NxDropdownModule,
    NxErrorModule,
    NxErrorModule,
    NxFormfieldModule,
    NxGridModule,
    NxHeaderModule,
    NxHeadlineModule,
    NxIconModule,
    NxIndicatorModule,
    NxInputModule,
    NxLinkModule,
    NxListModule,
    NxMenuModule,
    NxMessageModule,
    NxModalModule.forRoot(),
    NxNativeDateModule,
    NxNaturalLanguageFormModule,
    NxNaturalLanguageFormModule,
    NxNumberStepperModule,
    NxPageSearchModule,
    NxPaginationModule,
    NxPopoverModule,
    NxProgressStepperModule,
    NxProgressbarModule,
    NxRadioModule,
    NxRadioToggleModule,
    NxSpinnerModule,
    NxSwitcherModule,
    NxTableModule,
    NxTabsModule,
    NxTaglistModule,
    ReactiveFormsModule,
    RouterModule,
    SyncScrollModule,
    TextFieldModule,
    TranslateModule,
    TableSortMbComponent,
    DashboardAnnouncementsComponent,
    PieChartComponent,
    LineChartComponent,
    StackedGroupsChartComponent,
    GroupsChartComponent,
    IsBtnLinkValidPipe,
    DateFormatPipe,
    ListFilterPipe,
    NumberToReadablePipe,
    SafeHtmlPipe,
    SortAlphabetPipe,
    HasRoleDirective,
    OnlyNumberDirective,
    NxPopoverControllerDirective,
    ScrollTopComponent,
    NxMaskModule,
    NxTooltipModule,
    NxVideoModule,
    NxMomentDateModule,
    NxLabelModule,
    MatMenuModule,
    ScrollTopComponent,
  ],
  exports: [
    CommonModule,
    ExternalScrollbarModule,
    FormsModule,
    NxAccordionModule,
    NxActionModule,
    NxAutocompleteModule,
    NxBadgeModule,
    NxBreadcrumbModule,
    NxButtonComponent,
    NxButtonModule,
    NxCardModule,
    NxCheckboxModule,
    NxContextMenuModule,
    NxCopytextModule,
    NxDataDisplayModule,
    NxDatefieldModule,
    NxDropdownModule,
    NxErrorModule,
    NxFormfieldModule,
    NxGridModule,
    NxHeaderModule,
    NxHeadlineModule,
    NxIconModule,
    NxIndicatorModule,
    NxInputModule,
    NxLinkModule,
    NxListModule,
    NxMenuModule,
    NxMessageModule,
    NxModalModule,
    NxNativeDateModule,
    NxNaturalLanguageFormModule,
    NxNaturalLanguageFormModule,
    NxNumberStepperModule,
    NxPageSearchModule,
    NxPageSearchModule,
    NxPaginationModule,
    NxPopoverComponent,
    NxPopoverModule,
    NxProgressStepperModule,
    NxProgressbarModule,
    NxRadioModule,
    NxRadioToggleModule,
    NxSpinnerModule,
    NxSwitcherModule,
    NxTableModule,
    NxTabsModule,
    NxTaglistModule,
    ReactiveFormsModule,
    RouterModule,
    SyncScrollModule,
    TextFieldModule,
    TranslateModule,
    TableSortMbComponent,
    DashboardAnnouncementsComponent,
    PieChartComponent,
    LineChartComponent,
    StackedGroupsChartComponent,
    GroupsChartComponent,
    IsBtnLinkValidPipe,
    DateFormatPipe,
    ListFilterPipe,
    NumberToReadablePipe,
    SafeHtmlPipe,
    SortAlphabetPipe,
    HasRoleDirective,
    OnlyNumberDirective,
    NxPopoverControllerDirective,
    ScrollTopComponent,
    NxMaskModule,
    NxTooltipModule,
    NxVideoModule,
    NxMomentDateModule,
    CampaignCardComponent,
    ClubCampaignCardComponent,
    NumberToReadablePipe,
    PreviewCampaignCardComponent,
    EventCardComponent,
    FormPaginationComponent,
    SearchFormPaginationComponent,
    SearchFormPaginationCustomMbComponent,
    TableSortMbComponent,
    NxLabelModule,
    CustomStepperComponent,
    MatMenuModule,
    HasRoleDirective,
    ScrollTopComponent,
  ],
})
export class SharedModule {}
